import React from "react";
import Button from "sushiweb/Button";
import { BottomSectionModal } from "../../../constants/assets/containers";
import NoFooterModal from "../../Common/NoFooterModal";
import Input from "sushiweb/InputTypes/Input";
import { connect } from "react-redux";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { bindActionCreators } from "redux";
import * as IssueTypesActions from "../../../store/actions/IssueTypes";
import { isValNull } from "../../../utils";

const enabledType = ["Yes", "No"];

const IssueTypeFilterModal = (props) => {
  const {
    handleModalClose,
    issueArea,
    getIssueArea,
    activeFilters,
    setActiveFilters,
    getIssueTypeList,
  } = props;
  const [filterFieldState, setFilterFieldState] = React.useState({
    issueName: "",
    externalMappingName: "",
    enabled: null,
    issueArea: "",
  });
  React.useEffect(() => {
    if (issueArea.length === 0) {
      getIssueArea();
    }
  }, []);
  React.useEffect(() => {
    if (Object.keys(activeFilters).length > 0) {
      let values = { ...filterFieldState };
      Object.keys(values).map((item, index) => {
        if (!isValNull(activeFilters[item])) {
          values[item] = activeFilters[item] ? activeFilters[item] : "";
        }
      });
      setFilterFieldState(values);
    }
  }, [activeFilters]);

  const handleChange = (key, value) => {
    setFilterFieldState((prevState) => {
      return { ...prevState, [key]: value };
    });
  };
  const handleSubmit = () => {
    getIssueTypeList(1, filterFieldState).then((res) => {
      if (res) {
        // setActiveFilters(activeFiltersObj);
        handleModalClose();
      }
    });
  };
  const handleClearFilters = () => {
    getIssueTypeList(1, {}).then((res) => {
      setActiveFilters({});
      handleModalClose();
    });
  };
  return (
    <NoFooterModal
      header
      heading="Apply filters"
      handleClose={handleModalClose}
      id="filtersModalIssueTypes"
      modalButtons={
        <BottomSectionModal className="flex item-center justify-between">
          <Button
            data-testid="launchAppReleaseBtn"
            onClick={handleClearFilters}
            className="sushi-btn"
            appearance="outline"
          >
            Clear
          </Button>
          <Button
            data-testid="launchAppReleaseBtn"
            onClick={handleSubmit}
            className="sushi-btn"
          >
            Apply
          </Button>
        </BottomSectionModal>
      }
    >
      <Input
        id="sushi-input"
        value={filterFieldState.issueName}
        fullWidth={true}
        label="Issue Name"
        type="text"
        onChange={(val) => handleChange("issueName", val)}
      />
      <Input
        id="sushi-input"
        value={filterFieldState.externalMappingName}
        fullWidth={true}
        label="External Mapping Name"
        type="text"
        onChange={(val) => handleChange("externalMappingName", val)}
      />
      <PaginatedReactDropdown
        options={enabledType}
        handleChange={handleChange}
        keyToChange="enabled"
        placeholder="Enabled"
        showCross={true}
        id="issueTypeField"
        fullWidth={true}
        labelWidth="auto"
        value={filterFieldState.enabled}
      />
      <PaginatedReactDropdown
        options={issueArea}
        handleChange={handleChange}
        keyToChange="issueArea"
        placeholder="Issue Area"
        labelKey="name"
        valueKey="name"
        showCross={true}
        id="issueTypeField"
        fullWidth={true}
        labelWidth="auto"
        value={filterFieldState.issueArea}
      />
    </NoFooterModal>
  );
};
const mapStateToProps = (state) => {
  const { IssueTypes } = state;
  return {
    issueArea: IssueTypes.issueArea,
    activeFilters: IssueTypes.activeFilters,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getIssueArea: bindActionCreators(IssueTypesActions.getIssueArea, dispatch),
    setActiveFilters: bindActionCreators(
      IssueTypesActions.setActiveFilters,
      dispatch
    ),
    getIssueTypeList: bindActionCreators(
      IssueTypesActions.getIssueTypeList,
      dispatch
    ),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueTypeFilterModal);
